export const notificationsSliceName = "notification"
